// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5982":"8160bc28","9691":"df6efc40"}[chunkId] + ".chunk.css";
};